import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
// import { createStructuredSelector } from 'reselect';
import Highlighter from 'react-highlight-words';
import { Form, message, Button, Drawer, Input, Col, Row, Select } from 'antd';
import localStorage from '../../../utils/localStorage';
import { DrawerFooter } from './style';
import StyledTable from '../../../commons/styles/table';
import { constant } from '../Constants';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';

const { Option } = Select;
const FormItem = Form.Item;

const WarningLimits = (props) => {
  const [visible, setVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [editObject, setEditObject] = useState({});
  const [searchText, setSearchText] = useState('');
  const [deviceList, setDeviceList] = useState([]);
  const [parameterList, setParameterList] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || '');
  const [userId, setUserId] = useState(props.userDetails);
  const myRef = useRef();

  useEffect(() => {
    _getTranslationMasterData();
    _getDeviceList();
    setUserId(props.userDetails);
  }, []);

  useEffect(() => {
    if (translationCache) {
      setTranslationCache(translationCache);
    }
  }, [translationCache]);

  const _getDeviceList = () => {
    const SiteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    axios.get(`/api/device/get?SiteId=${SiteId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then((response) => {
        if (response.data) {
          setDeviceList(response.data);
        }
      })
      .catch((error) => {
        message.error(error);
        setDeviceList([]);
      });
  };

  const _getParameterListByDevice = (DeviceCode) => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    axios.post(`/api/deviceParameter/deviceParameters?SiteId=${siteId}`, {
      DeviceCode: [[DeviceCode]],
      SiteId: siteId
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        if (response.data && response.data.Operational) {
          setParameterList(response.data.Operational);
        }
      })
      .catch(() => {
        message.error('Error');
        setParameterList([]);
      });
  };

  const _getTranslationMasterData = () => {
    const SiteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    axios.get(`/api/WarningLimits/get?SiteId=${SiteId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then((response) => {
        if (response.data && Array.isArray(response.data)) {
          setDataSource(response.data);
        }
      })
      .catch(() => {
        message.error('Error loading list');
      });
  };

  const showDrawer = (e, record, type) => {
    e.preventDefault();
    if (type === 'edit') {
      _getParameterListByDevice(record.DeviceCode);
    } else {
      record = {
        ...record,
        data: [
          { Warning: 'Warning-1', Type: 'HIGH', LowerLimit: '', UpperLimit: '' },
          { Warning: 'Warning-1', Type: 'LOW', LowerLimit: '', UpperLimit: '' },
          { Warning: 'Warning-2', Type: 'HIGH', LowerLimit: '', UpperLimit: '' },
          { Warning: 'Warning-2', Type: 'LOW', LowerLimit: '', UpperLimit: '' },
          { Warning: 'Warning-3', Type: 'HIGH', LowerLimit: '', UpperLimit: '' },
          { Warning: 'Warning-3', Type: 'LOW', LowerLimit: '', UpperLimit: '' }
        ]
      };
    }
    if (myRef.current) {
      myRef.current.setFieldsValue({
        DeviceCode: record.DeviceCode,
        ParameterDescription: record.ParameterDescription
      });
    }
    setEditObject(record);
    setVisible(true);
  };

  const onClose = () => {
    setEditObject({});
    setVisible(false);
  };

  const saveWarning = () => {
    myRef.current.validateFields().then(async (values) => {
      const filteredParameter = parameterList.filter(parameter => parameter.ParameterCode === values.ParameterDescription);
      const saveWarnings = {
        ...editObject,
        DeviceCode: values.DeviceCode,
        ParameterCode: filteredParameter[0]?.ParameterCode || editObject.ParameterCode,
        ParameterDescription: filteredParameter[0]?.ParameterDescription || editObject.ParameterDescription,
        TagId: filteredParameter[0]?.TagId || editObject.TagId
      };
      _curdWarnings(saveWarnings, 'create');
      if (myRef.current) myRef.current.resetFields();
      setVisible(false);
    });
  };

  const updateWarning = () => {
    myRef.current.validateFields().then(async (values) => {
      const filteredParameter = parameterList.filter(parameter => parameter.ParameterCode === values.ParameterDescription);
      const updateWarnings = {
        ...editObject,
        DeviceCode: values.DeviceCode,
        ParameterCode: filteredParameter[0]?.ParameterCode || editObject.ParameterCode,
        ParameterDescription: filteredParameter[0]?.ParameterDescription || editObject.ParameterDescription,
        TagId: filteredParameter[0]?.TagId || editObject.TagId,
        Id: editObject.Id,
        CreatedBy: userId
      };
      _curdWarnings(updateWarnings, 'updateWarning');
      if (myRef.current) myRef.current.resetFields();
      setVisible(false);
    });
  };

  const _curdWarnings = (saveObject, curdOperation) => {
    const SiteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    axios.post(`/api/WarningLimits/${curdOperation}?SiteId=${SiteId}`, {
      ...saveObject,
      SiteId
    }, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then((response) => {
        if (response.status === 200) {
          message.success(response.data.message);
        }
        _getTranslationMasterData();
      })
      .catch(() => { });
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"

          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('');
  };

  const deviceOnChange = async (deviceCode) => {
    await _getParameterListByDevice(deviceCode);
  };

  const handleFieldChange = (e, parameter, index) => {
    const updatedData = editObject.data.map((item, idx) =>
      idx === index ? { ...item, [parameter]: e } : item
    );
    setEditObject({ ...editObject, data: updatedData });
  };

  const translation = (keyword) => {
    return translationCache[keyword] || keyword;
  };

  const columns = [
    {
      title: translation('Device'),
      dataIndex: 'DeviceName',
      key: 'DeviceName',
      width: '25%',
      ...getColumnSearchProps('DeviceName')
    },
    {
      title: translation('Parameter'),
      dataIndex: 'ParameterDescription',
      width: '25%',
      key: 'ParameterDescription',
      ...getColumnSearchProps('ParameterDescription')
    },
    {
      title: translation('Edit'),
      dataIndex: '',
      key: '',
      width: '25%',
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            className="ant-btn"
            onClick={(e) => showDrawer(e, record, 'edit')}
          >
            <EditOutlined />
          </Button>
        </div>
      )
    }
  ];

  return (
    <div>
      <Button type="primary" onClick={(e) => showDrawer(e, {}, 'new')}>
        {translation(constant.AddWarningLimits)}
      </Button>
      <Drawer
        title={
          !editObject.DeviceCode
            ? translation(constant.Create_Warning_Limits)
            : translation(constant.Update_Warning_Limits)
        }
        placement="right"
        closable={true}
        width={800}
        onClose={onClose}
        open={visible}
      >
        <Form
          layout="vertical"
          initialValues={editObject}
          ref={myRef}
        >
          <Row>
            <Col span={24}>
              <FormItem
                name="DeviceCode"
                label={translation(constant.Device)}
                rules={[{ required: true, message: 'Equipment is required' }]}
              >
                <Select
                  placeholder="Select Equipment"
                  onSelect={deviceOnChange}
                  disabled={!!editObject.DeviceCode}
                >
                  {deviceList.map(item => (
                    <Option key={item.Id} value={item.DeviceCode}>
                      {item.Name}
                    </Option>
                  ))}
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FormItem
                name="ParameterDescription"
                label={translation(constant.Parameter)}
                rules={[{ required: true, message: 'Parameter is required' }]}
              >
                <Select
                  placeholder="Select Parameter"
                  disabled={!!editObject.DeviceCode}
                >
                  {parameterList.map(item => (
                    <Option key={item.Id} value={item.ParameterCode}>
                      {item.ParameterDescription}({item.ParameterCode})
                    </Option>
                  ))}
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Form.Item>
              {editObject.data && editObject.data.map((k, index) => (
                <Row key={index}>
                  <Col span={5}>
                    <Form.Item
                      name={[index, 'Warning']}
                      label={index === 0 ? translation(constant.Warning) : ''}
                      rules={[{ required: true, message: 'Warning is required' }]}
                    >
                      <Input
                        defaultValue={k.Warning}
                        style={{ width: '90%' }}
                        placeholder="Input Warning"
                        onBlur={(e) => handleFieldChange(e.target.value, 'Warning', index)}
                        value={k.Warning}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      name={[index, 'Type']}
                      label={index === 0 ? translation(constant.Type) : ''}
                      rules={[{ required: true, message: 'Type is required' }]}
                    >
                      <Input
                        defaultValue={k.Type}
                        style={{ width: '90%' }}
                        placeholder="Input Type"
                        onBlur={(e) => handleFieldChange(e.target.value, 'Type', index)}
                        value={k.Type}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      name={[index, 'LowerLimit']}
                      label={index === 0 ? translation(constant.LowerLimit) : ''}
                      rules={[{ required: true, message: 'LowerLimit is required' }]}
                    >
                      <Input
                        defaultValue={k.LowerLimit}
                        value={k.LowerLimit}
                        style={{ width: '90%' }}
                        placeholder="Input LowerLimit"
                        onChange={(e) => handleFieldChange(e.target.value, 'LowerLimit', index)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      name={[index, 'UpperLimit']}
                      label={index === 0 ? translation(constant.UpperLimit) : ''}
                      rules={[{ required: true, message: 'UpperLimit is required' }]}
                    >
                      <Input
                        defaultValue={k.UpperLimit}
                        value={k.UpperLimit}
                        style={{ width: '90%' }}
                        placeholder="Input UpperLimit"
                        onChange={(e) => handleFieldChange(e.target.value, 'UpperLimit', index)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ))}
            </Form.Item>
          </Row>
          <DrawerFooter>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              {translation(constant.Cancel)}
            </Button>
            {!editObject.DeviceCode ? (
              <Button type="primary" onClick={saveWarning}>
                {translation(constant.Create)}
              </Button>
            ) : (
              <Button type="primary" onClick={updateWarning}>
                {translation(constant.Update)}
              </Button>
            )}
          </DrawerFooter>
        </Form>
      </Drawer>
      <StyledTable size="small" columns={columns} dataSource={dataSource} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(WarningLimits);